var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import '../../shared/css/generic-styles.css';
import '../../shared/css/Icon.css';
import { useThemeableSystemData } from './Provider';
import { useThemeable } from './ProviderStyleAccess';
/**
 * # Icon
 * Import and use Themeable icons. Your prefered icon svg file must be placed in the root directory.
 *
 * [See Documentation](https://themeable.systems/documentation)
 *
 * ---
 *
 * ### Props:
 * `color`: Color override for the button.
 *
 * `name`: Name of the icon (ex: ChevronRight, Plus, HeartOutline, etc).
 *
 * `size`: Width and height of the icon.
 *
 */
var Icon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'var(--ts-size-base)' : _b, _c = _a.color, color = _c === void 0 ? 'icon' : _c, colorCustom = _a.colorCustom, className = _a.className, _d = _a.nested, nested = _d === void 0 ? false : _d, _e = _a.spacing, spacing = _e === void 0 ? 'normal' : _e;
    var svgPath = useThemeableSystemData().svgPath;
    var _f = useThemeable(), spacingMode = _f.spacingMode, space = _f.space;
    var iconStyles = {
        margin: spacing === 'grouped'
            ? undefined
            : spacingMode === 'normal'
                ? "".concat(space.vUnify + space.vExtra, "px ").concat(space.hUnify + space.hExtra, "px")
                : "".concat(space.vUnify, "px ").concat(space.hUnify, "px"),
    };
    var classes = [
        'icon',
        nested ? ' nested' : '',
        className ? className : '',
        "color-".concat(color)
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', className: classes, style: __assign(__assign({}, iconStyles), { width: "".concat(size), height: "".concat(size) }), children: _jsx("use", { href: "".concat(svgPath, "#icon").concat(name), style: { fill: colorCustom } }) }));
};
export { Icon };
